import { gql } from '@apollo/client';

export default gql`
  mutation resetPassword($email: String!, $password: String!, $token: String!) {
    resetPassword(input: { email: $email, password: $password, token: $token }) {
      success
    }
  }
`;
